import { useRef, useState, useEffect } from 'react';

// Height observer
export const useHeightObserver = () => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const [height, setHeight] = useState<number | null>(null);

	useEffect(() => {
		if (!containerRef.current) {
			return;
		}

		let prevHeight = containerRef.current.offsetHeight;
		setHeight(prevHeight);
		const observer = new ResizeObserver((entries) => {
			for (let entry of entries) {
				const newHeight = entry.contentRect.height;
				if (newHeight !== prevHeight) {
					prevHeight = newHeight;
					setHeight(newHeight);
				}
			}
		});
		observer.observe(containerRef.current);
		return () => observer.disconnect();
	}, []);

	return { containerRef, height };
};
